import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type Stores = Static<typeof StoresSchema>;
export const StoresSchema = Type.Array(
  Type.Object({
    id: Type.String(),
    displayName: Type.String(),
  })
);
